<template>
    <el-container class="list-page">
        <el-header class="list-page-header">
            <h1 class="list-page-title">Expenses</h1>
            <div class="list-page-search">
                <el-input prefix-icon="el-icon-search" v-model="searchContent"
                          placeholder="Search your expenses"></el-input>
            </div>
            <el-button class="list-page-add-button" type="primary" :disabled="cantAddInvoice" @click.native.prevent="goAddInvoice">
                <i class="el-icon-plus"></i>
                <span>Add expense</span>
            </el-button>
        </el-header>
        <el-main class="list-page-main">
            <template>
                <div class="list-table-card">
                    <el-table class="list-table" @sort-change="sortTable" v-loading="loading" :data="tableData"
                              :default-sort="{prop: 'expenseDate', order: 'descending'}"
                              @row-click='handleRowHandle'>

                        <el-table-column prop="expenseDescription" label="Description" min-width="320">
                            <template slot-scope="scope">
                                <span class="list-description-cell" v-if="scope.row.expenseDescription">{{scope.row.expenseDescription}}</span>
                                <span class="list-cell-empty" v-else>—</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="expenseDate" label="Date" :formatter="dateFormat" sortable="custom" min-width="160">
                            <template slot="header">
                                <span class="list-sort-header" :class="{'is-active': orderName === 'expenseDate'}">
                                    Date
                                    <svg v-if="orderName === 'expenseDate'" class="list-sort-icon is-active" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                        <path v-if="orderName === 'expenseDate' && orderTpe === 1" d="M8 6L12 2L16 6"/>
                                        <path v-else d="M8 18L12 22L16 18"/>
                                        <path d="M12 2V22"/>
                                    </svg>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="total" label="Total" :formatter="amountFormat" sortable="custom" min-width="140" align="right" header-align="right">
                            <template slot="header">
                                <span class="list-sort-header" :class="{'is-active': orderName === 'total'}">
                                    Total
                                    <svg v-if="orderName === 'total'" class="list-sort-icon is-active" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                        <path v-if="orderName === 'total' && orderTpe === 1" d="M8 6L12 2L16 6"/>
                                        <path v-else d="M8 18L12 22L16 18"/>
                                        <path d="M12 2V22"/>
                                    </svg>
                                </span>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
                <div class="list-pagination">
                    <el-pagination
                            @size-change="changeTotalCount"
                            @current-change="changePage"
                            :current-page="currentPage"
                            :page-sizes="[50, 100, 200, 400]"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalCount">
                    </el-pagination>
                </div>
            </template>
        </el-main>
    </el-container>
</template>

<script>
    import {formatEnglishDate} from '@/utils/time'
    import {debounce} from '@/utils/debounce'
    import {xiaoshudianfenge} from '@/utils/moneyFormat'

    export default {
        methods: {
            goAddInvoice() {
                let self = this;
                self.$router.push('/createExpense');
            },
            queryList() {
                let that = this;
                this.loading = true;
                this.cantAddInvoice = true;
                this.$axios.post('query_expense_list_user_web', {
                    params: {
                        "currentPage": that.currentPage,
                        "pageSize": that.pageSize,
                        "orderName": that.orderName,
                        "orderTpe": that.orderTpe,
                        "userWebCommonQuery": that.searchContent
                    }
                }).then(response => {
                    if (response.data.errorCode === 0) {
                        that.tableData = response.data.dataList;
                        that.totalCount = response.data.totalCount;
                        that.totalTypeCount = response.data.totalTypeCount;
                        that.userSetting = JSON.parse(localStorage.getItem('userSetting'));
                    }
                    that.loading = false;
                    that.cantAddInvoice = false;

                }).catch(function () {
                    that.loading = false;
                    that.cantAddInvoice = false;
                })
            },
            sortTable(column) {
                if (!column.order) {
                    this.orderName = "";
                    this.orderTpe = "";
                    this.queryList();
                    return;
                }
                this.orderName = column.prop;
                if (column.order === "ascending") {
                    this.orderTpe = 1
                } else if (column.order === "descending") {
                    this.orderTpe = 2
                }
                this.queryList();
            },
            changePage(val) {
                this.currentPage = val;
                this.queryList();
            },
            changeTotalCount(val) {
                this.pageSize = val;
                this.queryList();
            },
            handleRowHandle(row, event, column) {
                //点击每一条列表数据触发的方法
                if (column.className === "el-table-column--selection") {
                    return false;
                } else {
                    //因为需要考虑详情里面的刷新 所以把拿过去的信息放在缓存里面
                    this.$router.push({path: 'updateExpense', query: {innerUUID: row.innerUUID}});
                }
            },
            //时间格式化
            dateFormat: function (row, column) {
                var timestamp = row[column.property] * 1000;
                if (timestamp == undefined) {
                    return "";
                }
                return formatEnglishDate(timestamp);
            },
            //金钱格式化,增加金钱符号和分隔符
            amountFormat: function (row, column) {
                var columnAmount = row[column.property];
                if (columnAmount == undefined) {
                    return "";
                }
                return xiaoshudianfenge(columnAmount, this.userSetting);
            }

        },
        data() {
            return {
                tableData: [],
                loading: true,
                currentPage: 1,
                totalCount: 0,
                pageSize: 50,
                orderName: "expenseDate",
                orderTpe: 2,
                userSetting: {},
                cantAddInvoice: false,
                totalTypeCount: 0,
                searchContent:''
            }
        },
        mounted() {
            this.queryList();
            this.$watch('searchContent', debounce(() => {
                this.queryList();
            }, 500))
        }
    }
</script>
